
import { useState } from 'react';
import { PushNotificationOff, PushNotificationOn } from "../../../components/common/IconComponents";

const NotificationTab = () => {
  const options = [
    "A new application is submitted",
    "A decision is made on a loan application",
    "A loan is approved despite failing the prediction model",
    "I receive direct messages",
    "A new prediction model is created",
  ];

  const [isPushNotificationOn, setPushNotificationOn] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);

  const handlePushNotificationToggle = () => {
    setPushNotificationOn(!isPushNotificationOn);
  };

  const handleCheckboxChange = (event) => {
    const checkboxValue = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setCheckedItems([...checkedItems, checkboxValue]);
    } else {
      const updatedItems = checkedItems.filter((item) => item !== checkboxValue);
      setCheckedItems(updatedItems);
    }
  };

  const isCheckboxChecked = (option) => {
    return checkedItems.includes(option);
  };

  return (
    <div className="">
      <div className="mx-3">
        <nav className="md:w-[662px] sticky md:fixed z-20 top-16 md:top-0 bg-white">
          <h1 className="mt-4 py-2 text-lg md:text-[28px] font-medium">Notification</h1>
        </nav>
        
        <div className="">
          <div className="mt-4 md:mt-24 mb-4">
            <div className="flex justify-between items-center mb-5">
              <div className="">
                <h1 className="text-activesettings-text text-lg font-normal mb-1">Push Notification</h1>
                <p className="text-teams-body-text text-xs font-normal">
                  Get push notification to stay updated with what is going on when you are not on SMARTLEND. <br />You can turn it off anytime.
                </p>
              </div>

              {isPushNotificationOn ? (
                <PushNotificationOn onClick={handlePushNotificationToggle} />
              ) : (
                <PushNotificationOff onClick={handlePushNotificationToggle} />
              )}
            </div>

            <div className="flex justify-between items-center mb-5">
              <div>
                <h1 className="text-activesettings-text text-lg font-normal mb-1">Email Notification</h1>
                <p className="text-teams-body-text text-xs font-normal">
                  Get email notification to stay updated with what is going on when you are not on SMARTLEND. <br /> You can turn it off anytime.
                </p>
              </div>

              {isPushNotificationOn ? (
                <PushNotificationOn onClick={handlePushNotificationToggle} />
              ) : (
                <PushNotificationOff onClick={handlePushNotificationToggle} />
              )}
            </div>

            <div className="mb-8">
              <h1 className="text-activesettings-text text-lg font-medium mb-1">Email Notification</h1>
              <ul>
                {options.map((option, index) => (
                  <li key={index} className="text-teams-body-text text-xs font-normal mb-1">
                    <label>
                      <input
                        className="rounded-sm mr-1"
                        type="checkbox"
                        value={option}
                        onChange={handleCheckboxChange}
                        checked={isCheckboxChecked(option)}
                      />
                      <span
                        className={`checkbox-button ${isCheckboxChecked(option) ? 'bg-enabled-btn text-white' : ''
                          }`}
                      />
                      {option}
                    </label>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationTab;


// import { useState } from 'react';
// import { PushNotificationOff, PushNotificationOn } from "../../../components/common/IconComponents";

// const NotificationTab = () => {
//   const options = [
//     "A new application is submitted",
//     "A decision is made on a loan application",
//     "A loan is approved despite failing the prediction model",
//     "I receive direct messages",
//     "A new prediction model is created",
//   ];

//   const [isPushNotificationOn, setPushNotificationOn] = useState(false);
//   const [checkedItems, setCheckedItems] = useState([]);

//   const handlePushNotificationToggle = () => {
//     setPushNotificationOn(!isPushNotificationOn);
//   };

//   const handleCheckboxChange = (event) => {
//     const checkboxValue = event.target.value;
//     const isChecked = event.target.checked;

//     if (isChecked) {
//       setCheckedItems([...checkedItems, checkboxValue]);
//     } else {
//       const updatedItems = checkedItems.filter((item) => item !== checkboxValue);
//       setCheckedItems(updatedItems);
//     }
//   };

//   const isCheckboxChecked = (option) => {
//     return checkedItems.includes(option);
//   };


//   return (
//     <div className="">
//       <div className="mx-3">
//         <h1 className="mt-4 text-[28px] font-medium">Notification</h1>

//         <div className="">
//           <div className="mt-4">
//             <div className="flex justify-between items-center mb-4">
//               <div>
//                 <h1 className="text-activesettings-text text-sm font-normal mb-1">Push Notification</h1>
//                 <p className="text-teams-body-text text-xs font-normal">
//                   Get push notification to stay updated with what is going on when you are not on SMARTLEND. <br />You can turn it off anytime.
//                 </p>
//               </div>

//               {isPushNotificationOn ? (
//                 <PushNotificationOn onClick={handlePushNotificationToggle} />
//               ) : (
//                 <PushNotificationOff onClick={handlePushNotificationToggle} />
//               )}
//             </div>

//             <div className="flex justify-between items-center mb-4">
//               <div>
//                 <h1 className="text-activesettings-text text-sm font-normal mb-1">Email Notification</h1>
//                 <p className="text-teams-body-text text-xs font-normal">
//                   Get email notification to stay updated with what is going on when you are not on SMARTLEND. <br /> You can turn it off anytime.
//                 </p>
//               </div>

//               {isPushNotificationOn ? (
//                 <PushNotificationOn onClick={handlePushNotificationToggle} />
//               ) : (
//                 <PushNotificationOff onClick={handlePushNotificationToggle} />
//               )}
//             </div>

//             <div>
//               <h1 className="text-activesettings-text text-sm font-medium mb-1">Email Notification</h1>
//               <ul>
//                 {options.map((option, index) => (
//                   <li key={index}
//                     className={`text-teams-body-text text-xs font-normal mb-1 ${isCheckboxChecked(option) ? 'bg-enabled-btn text-white' : ''
//                       }`}
//                   >
//                     <label>
//                       <input
//                         className="rounded-sm mr-1"
//                         type="checkbox"
//                         value={option}
//                         onChange={handleCheckboxChange}
//                         checked={isCheckboxChecked(option)}
//                       />
//                       {option}
//                     </label>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default NotificationTab







